// extracted by mini-css-extract-plugin
export default {"row":"createRMG_row__Lc2qH","col":"createRMG_col__HKF-d","card":"createRMG_card__P6QNB"};